import { Link } from 'react-router-dom'
import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import Spinner from '../Spinner/Spinner'
import { Table } from 'reactstrap'
import { ACTIVITY_LOG_SUMMARY_QUERY } from '../../graphql'
import './ActivityLog.css'

const ACTIVITY_LOG_SUMMARY = gql(ACTIVITY_LOG_SUMMARY_QUERY)

export default function ActivityLogSummary({ parameters }) {
  console.log('ActivityLogSummary rendered: ', parameters)

  const { loading, error, data } = useQuery(ACTIVITY_LOG_SUMMARY, {
    variables: {
      fromDate: parameters.fromDate,
      toDate: parameters.toDate
    }
  })
  if (loading) {
    return <Spinner />
  }
  if (error) {
    return <div>{error.message}</div>
  }

  const rows = []
  if (data.getActionSummary) {
    data.getActionSummary.forEach((dataRow, index) => {
      const row =
        <tr key={index}>
          <td><Link to={`/custom/document_view.display_audit_log?objectTypeId=${dataRow.objectTypeId}&fromDate=${parameters.fromDate}&toDate=${parameters.toDate}`}>{dataRow.objectTypeName}</Link></td>
          <td className="right">{dataRow.actionTypeName}</td>
          <td className="right">{dataRow.count}</td>
        </tr >
      rows.push(row)
    })
  }

  return (
    <div className="activitylog-grid-container">
      <div className="activitylog-grid-table-container">
        <Table className="activitylog-grid-table" bordered size="sm">
          <thead>
            <tr>
              <th>Entity Type</th>
              <th>Event Name</th>
              <th>Counts</th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </Table>
      </div>
    </div>
  )
}